import { useState } from 'react';
import * as _ from 'lodash';

export function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return (props: { defer?: boolean } = {}) => {
    // in some cases we may wish to defer rendering if mobx is (for example) mostly controlling a component.
    // this essentially prevents a re-render during a re-render (which would throw a warning)
    if (props.defer) {
      return _.defer(() => {
        // update the state to force render
        setValue((value) => value + 1);
      });
    }
    setValue((value) => value + 1);
  };
}
